// extracted by mini-css-extract-plugin
module.exports = {"rail":"style_rail__ht6BQ","slider":"style_slider__X_8EF"};